import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-navy-light">
    <div className="animate-pulse text-navy font-display font-bold">Loading AAWTA Dashboard…</div>
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !admin) navigate("/admin/login", { replace: true });
  }, [loading, admin, navigate]);

  if (loading) return <Loading />;
  if (!admin) return <Loading />; // redirecting to login
  return children;
};
